import { Component, Element, h } from '@stencil/core';

@Component({
  tag: 'lar-list-header',
  styleUrl: 'list-header.scss',
  shadow: true
})

export class ListHeader {
  @Element() el!: HTMLElement;

  render() {
    return [
      <slot name="start"/>,
      <div class="item-inner">
        <slot />
      </div>,
      <slot name="end"/>
    ];
  }
}
